<template>
  <div class="tag-display-and-input-area" ref="tag-display-and-input-area">
    <el-tag
      v-for="(tag, index) in accounts"
      :key="index"
      closable
      :disable-transitions="false"
      effect="plain"
      size="medium"
      type="warning"
      @close="handleClose(tag)"
      >{{ tag }}
    </el-tag>
    <el-input
      class="input-new-tag"
      v-if="inputVisible"
      v-model="inputValue"
      ref="saveTagInput"
      size="mini"
      @keyup.enter.native="handleInputConfirm"
      @blur="handleInputConfirm"
    >
    </el-input>
    <el-button v-else class="button-new-tag" size="small" type="warning" plain @click="showInput"
      >+ Account ID</el-button
    >
  </div>
</template>

<script>
import { Tag } from "element-ui";
export default {
  components: {
    [Tag.name]: Tag
  },
  props: {
    accounts: Array
  },
  data() {
    return {
      inputVisible: false,
      inputValue: "",
      tmp: []
    };
  },
  mounted() {},
  methods: {
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        let separator = /,| /;
        let inputValueSeparateArr = inputValue.split(separator);
        inputValueSeparateArr = inputValueSeparateArr.filter(value => value !== '');
        let inputValueSeparateArrToNumber = inputValueSeparateArr.map(number => Number(number));
        if(!this.checkEveryElementTypeOfNumber(inputValueSeparateArrToNumber)) {
            this.$message({
                type: "error",
                message: "請輸入數字"
            });
        } else {
            let concatedArr = this.accounts.concat(inputValueSeparateArr);
            this.accounts = Array.from(new Set(concatedArr));
            this.$emit('add-new-tag', this.accounts);
        }
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    checkEveryElementTypeOfNumber(arr) {
        return arr.every(element => {
            return typeof element === 'number' && element > 0
        });
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleClose(tag) {
      this.accounts.splice(this.accounts.indexOf(tag), 1);
    }
  }
};
</script>

<style>
.tag-display-and-input-area {
  margin-top: 20px;
  border: 1px solid #000;
  width: 100%;
  min-height: 100px;
  padding: 2px;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
